export default __webpack_public_path__ + "static/media/popup-text.33d4fad4.svg";